exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.project-drawer .v-overlay {\n  z-index: 700;\n}\n.project-drawer .v-overlay--absolute {\n  position: fixed;\n}\n.project-drawer .v-navigation-drawer--open {\n  width: 496px !important;\n}\n.project-drawer .v-navigation-drawer--absolute {\n  position: fixed;\n  z-index: 1000;\n}\n", ""]);

// exports
